<div class="modal-header">
    <h5 *ngIf="!emailSent" class="modal-title">Email confirmation</h5>
    <button
            type="button"
            class="close"
            (click)="onClose()"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg"
             viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
        </svg>
    </button>
</div>
<div class="pb-3">
    <div class="modal-body">
        <div class="pb-2">
            <p *ngIf="!error" class="mb-2">Please provide your email for confirmation</p>
            <p *ngIf="error || warning" class=" text-danger">{{error || warning}}</p>
            <div *ngIf="!error">
                <div class="form-control">
                    <input [(ngModel)]="email" type="email" placeholder="Email"/>
                </div>
                <button class="login-button" [disabled]="!email" (click)="confirmEmail(email)">
                    Confirm
                </button>
            </div>
            <button *ngIf="error" class="login-button mt-2" [disabled]="!email" (click)="signInModal()">
                Sign in with email
            </button>
        </div>
    </div>
</div>
